import React, { Component } from 'react';
import * as Icons from '../images/index';

class IconsAccounts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            iconSrc: Icons[props.socialType] || null
        };
    }

    render() {
        const { socialType, width, height, style } = this.props;
        const { iconSrc } = this.state;

        return iconSrc ? <img src={iconSrc} alt={socialType} width={width} height={height} style={style} /> : null;
    }
}

export default IconsAccounts;
